import { Component, OnInit } from '@angular/core';
import { Company } from '../../../models/company';
import { Location } from '../../../models/location';
import { Product_Type } from '../../../models/product_Type';

import { AuthService } from '../../../services/auth.service';
import { CompanyService } from '../../../services/company.service';
import { LocationService } from '../../../services/location.service';
import { PDAUserService } from '../../../services/pda-user.service';
import { ReportableService } from '../../../services/reportable.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from '../../../services/modal.service';

import { saveAs as importedSaveAs } from 'file-saver';

import * as moment from 'moment';
import { Page } from '../../../models/paging/page';
import { ProductTypeService } from '../../../services/product-type.service';
import { CylinderStatusReportService } from '../../../services/cylinder_status_report.service';
import { Cylinder } from '../../../models/cylinder';
import { Valve_Model } from '../../../models/valve_Model';
import { ColumnService } from '../../../services/ColumnService';

@Component({
  selector: 'app-cylinder_status_report',
  templateUrl: './cylinder_status_report.component.html',
  styleUrls: ['./cylinder_status_report.component.css']
})
export class CylinderStatusReportComponent implements OnInit {

  companyService: CompanyService;
  locationService: LocationService;
  modalService: ModalService;

  companies: Company[];
  companyList: Company[];

  locations: Location[];
  locationList: Location[];

  cylinderMaterials: Cylinder[];
  cylinderSizes: Cylinder[];
  valveModels: Valve_Model[];
  productTypes: Product_Type[];

  filter: any = {
    customer_Type_Id: 0,

    company_Id: 0,
    in_Service: "All",
    location_Id: 0,
    created_From: moment().toDate(),
    created_To: moment().toDate(),
    show_All: false,
    cyl_Serial_Num: "",
    cyl_Size_Id: 0,
    cyl_Material_Id: 0,
    product_Type_Id: 0,
    tag_Id: "",
    valve_Serial_Num: "",
    valve_Model_Num_Id: 0,
    quick_Search: ''
  };

  selectedItems = Array<any>();
  allSelected = false;

  cylinder_Id: 0;
  cylinder_Serial_No: '';
  showHistory: boolean = false;

  viewtype: 0;
  page = new Page();
  rows = Array<any>();
  init: boolean;
  is_client = false;
  client;

  availableOptions: string[] = [
    'Checkbox',
    'Cylinder ID',
    'Cyl Serial #',
    'Cyl Material',
    'Product Type',
    'Cyl Size',
    'Cyl Manuf Date',
    'Cyl EOL Date',
    'Cyl Test Date',
    'In Service',
    'Customer Name',
    'Acc #',
    'Location',
    'Post Code',
    'Valve Serial #',
    'Valve Model #',
    'Owner Name',
    'Valve Manuf Date',
    'Valve EOL Date',
    'Tracking ID',
    'Move to missing area'
  ];

  selectedOptions: string[] = [
    'Cyl Serial #',
    'Cyl Material',
    'Product Type',
    'Cyl Size',
    'In Service',
    'Customer Name',
    'Tracking ID'
  ];

  constructor(authService: AuthService, companyService: CompanyService, locationService: LocationService, pdaUserService: PDAUserService,
    public cylinderStatusReportService: CylinderStatusReportService, public reportableService: ReportableService,
    modalService: ModalService, productTypeService: ProductTypeService, public router: Router, private route: ActivatedRoute,
    private columnService: ColumnService) {

    this.is_client = authService.currentUser.value.userType == 0;
    this.client = authService.currentUser.value;

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'desc';
    this.page.sortBy = "";

    productTypeService.getAll().then((data) => {
      this.productTypes = data;
    });

    cylinderStatusReportService.getAllCylinderSize().then((data) => {
      this.cylinderSizes = data;
    });

    cylinderStatusReportService.getAllCylinderMaterial().then((data) => {
      this.cylinderMaterials = data;
    });

    cylinderStatusReportService.getAllValveModels().then((data) => {
      this.valveModels = data;
    });

    companyService.getAll(this.filter.customer_Type_Id).then((data) => {
      this.companyList = data;
      this.companies = this.companyList;
      if (this.is_client) {
        this.filter.company_Id = authService.currentUser.value.company_Id;
        this.filter.location_Id = authService.currentUser.value.location_Id;
      }

      locationService.getAll(this.filter.company_Id).then((data) => {
        this.locationList = data;
        this.locations = this.locationList;

        if (this.is_client) {
          this.locations = this.locationList.filter(c => {
            return c.company_Id == this.filter.company_Id;
          });
        }
      });

      this.loadTable();
    });

    this.companyService = companyService;
    this.locationService = locationService;
    this.modalService = modalService;

  }

  ngOnInit() {
    this.getcolumns();
    this.loadTable();
  }


  onCompanyChange(value) {
    this.filter.location_Id = 0;
    this.filter.region_Id = 0;
    if (value == 0) { value = null; }

    this.locations = this.locationList.filter(c => {
      return value == null || c.company_Id == value;
    });
  }

  onCustomerTypeChange(value) {
    this.filter.company_Id = 0;
    this.onCompanyChange(0);

    if (value == 0) { value = null; }

    this.companies = this.companyList.filter(c => {
      return value == null || c.customer_Type_Id == value;
    });

  }

  async delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

openCylinderHistory(row: any): void {
  const selected = {
    cylinder_Id: row.cylinder_ID,
    cylinder_Serial_No: row.cyl_Serial_Num
  };

  try {
    localStorage.setItem('selectedCylinder', JSON.stringify(selected));
  } catch (e) {

    console.warn('Could not store selected cylinder in localStorage', e);
  }

  const urlTree = this.router.createUrlTree(
    ['/reports/cylinder_status_report/cylinder_history'],
    {
      queryParams: {
        cylinder_Id: selected.cylinder_Id,
        cylinder_Serial_No: selected.cylinder_Serial_No
      }
    }
  );

  const url = this.router.serializeUrl(urlTree);

  window.open(url, '_blank');
}


  // ###################################
  // TABLE
  // ###################################
  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;
    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }

    const sortMapping = {
      'cyl_Manuf_Date_Display': 'cyl_Manuf_Date_Sorting',
      'cyl_EOL_Date_Display': 'cyl_EOL_Date_Sorting',
      'cyl_Last_Test_Date_Display': 'cyl_Last_Test_Date_Sorting',
      'valve_Manuf_Date_Display': 'valve_Manuf_Date_Sorting',
      'valve_EOL_Date_Display': 'valve_EOL_Date_Sorting',
    };

    const sortBy = sortMapping[event.column.prop] || event.column.prop;

    this.page.sortOrder = event.newValue;
    this.page.sortBy = sortBy;
    this.loadTable();
  }

  loadTable() {
    this.cylinderStatusReportService.getResults(this.page, this.filter.company_Id, this.filter.location_Id, this.filter.in_Service,
      this.filter.created_From, this.filter.created_To, this.filter.show_All, this.filter.cyl_Serial_Num, this.filter.cyl_Size_Id,
      this.filter.cyl_Material_Id, this.filter.product_Type_Id, this.filter.tag_Id, this.filter.valve_Serial_Num,
      this.filter.valve_Model_Num_Id, this.filter.quick_Search).then((pagedData) => {

        this.page = pagedData.page;
        this.rows = pagedData.data;
        
        for (let i = 0; i < this.rows.length; i++) {
          let id = this.rows[i].cylinder_ID;
          if (this.selectedItems.find(i => i.cylinder_ID == id) != undefined) {
            this.rows[i].isSelected = true;
          }
          else {
            this.rows[i].isSelected = false;
          }
        }
        this.checkAllSelected();

        if (this.init) {
          this.gotoTop();
          this.init = false;
        }
      });
  }

  onRefresh() {
    this.page.pageNumber = 0;
    this.selectedItems = [];
    this.loadTable();
  }

  itemSelected(row: any) {
    if (this.selectedItems.find(i => i.cylinder_ID == row.cylinder_ID) == undefined) {
      this.selectedItems.push(row);
      this.rows.find(i => i.cylinder_ID == row.cylinder_ID).isSelected = true;
    }
    else {
      let index = this.selectedItems.findIndex(i => i.cylinder_ID == row.cylinder_ID);
      this.selectedItems.splice(index, 1);
      this.rows.find(i => i.cylinder_ID == row.cylinder_ID).isSelected = false;
    }

    this.checkAllSelected();
  }

  selectAll() {
    for (let i = 0; i < this.rows.length; i++) {
      let id = this.rows[i].cylinder_ID;
      if (this.selectedItems.find(i => i.cylinder_ID == id) == undefined) {
        this.selectedItems.push(this.rows[i]);
        this.rows[i].isSelected = true;
      }
    }

    this.checkAllSelected();
  }

  deselectAll() {

    for (let i = 0; i < this.rows.length; i++) {
      let id = this.rows[i].cylinder_ID;
      let index = this.selectedItems.findIndex(i => i.cylinder_ID == id);
      this.selectedItems.splice(index, 1);
      this.rows[i].isSelected = false;
    }

    this.checkAllSelected();
  }

  checkAllSelected() {
    for (let i = 0; i < this.rows.length; i++) {
      if (this.rows[i].isSelected == false) {
        this.allSelected = false;
        return;
      }
      else {
        this.allSelected = true;
      }
    }
  }

  archiveSelected() {

    let cylinders = Array<Cylinder>();

    for (let i = 0; i < this.selectedItems.length; i++) {
      var cylinder = new Cylinder();
      cylinder.cylinder_Id = this.selectedItems[i].cylinder_ID;
      cylinders.push(cylinder);
    }

    this.cylinderStatusReportService.archiveCylinder(cylinders).then((data) => {
      this.onRefresh();
    });
  }

  downloadReport(id: number) {
    this.reportableService.getDeliveryNotes(id).then((data) => {
      importedSaveAs(data, 'Delivery Notes.pdf');
    });
  }

  dateChange(ev) {
    if (ev == -1) {
      return;
    }

    let date = moment();
    if (ev == 0) {
      date = date.subtract(1, 'weeks');
    } else {
      date = date.subtract(ev, 'months');
    }

    let jsDate = date.toDate();
    //var startDate: NgbDateStruct = { year: jsDate.getFullYear(), month: jsDate.getMonth() + 1, day: jsDate.getDate() };
    this.filter.start_Date = jsDate;
  }

  generateExcelCylinders() {
    this.cylinderStatusReportService.generateExcelCylinders(this.filter.company_Id, this.filter.location_Id, this.filter.in_Service,
      this.filter.created_From, this.filter.created_To, this.filter.show_All, this.filter.cyl_Serial_Num, this.filter.cyl_Size_Id,
      this.filter.cyl_Material_Id, this.filter.product_Type_Id, this.filter.tag_Id, this.filter.valve_Serial_Num,
      this.filter.valve_Model_Num_Id, this.filter.quick_Search).then((data) => {
        importedSaveAs(data, 'Cylinders.xlsx');
      });
  }

  generateExcelReport() {
    this.cylinderStatusReportService.generateExcelReport(this.filter.company_Id, this.filter.location_Id, this.filter.in_Service,
      this.filter.created_From, this.filter.created_To, this.filter.show_All, this.filter.cyl_Serial_Num, this.filter.cyl_Size_Id,
      this.filter.cyl_Material_Id, this.filter.product_Type_Id, this.filter.tag_Id, this.filter.valve_Serial_Num,
      this.filter.valve_Model_Num_Id).then((data) => {
        importedSaveAs(data, 'Report.xlsx');
      });
  }

  gotoTop() {
    // window.scrollTo(-9999,-99999);
    let top = document.getElementById('top');

    if (top !== null) {
      top.scrollIntoView(true);
      //  document.getElementById("top").scrollTop -= 99999;
      top = null;
    }
  }

  handleSelectedColumns(selectedOptions: string[]): void {
    this.selectedOptions = selectedOptions;
    this.saveSelection();
  }

  getcolumns() {
    this.columnService.getColumns(this.client.userId, "cylinderStatusReport").then((data) => {
      if (data.columns != null) {
        this.selectedOptions = this.availableOptions.filter(c => {
          return data.columns.includes(c);
        });
      }

    });
  }

  saveSelection() {
    this.columnService.save(this.client.userId, "cylinderStatusReport", this.selectedOptions).then((data) => {
    });
  }

  async moveToMissing(row: any) {
    const cylinderId: number = row.cylinder_ID;

    try {
      const data = await this.cylinderStatusReportService.moveToMissingArea(cylinderId);
      this.onRefresh();
    } catch (error) {
    }
  }
}

